import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _uniq from 'lodash/uniq';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { setNodeData } from '../../../features/mainSlice';
import AutoCompletedTextField from '../../shared/AutoCompletedTextField';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    error: {
      borderColor: color.$17,
    },
  },
  {
    name: 'Location',
  },
);

const Location = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { triggerCondition } = selectedNode?.data;

  const groupId = selectedNode?.id;
  const isError = !!~isErrorNodeIds.indexOf(groupId);

  const onTagEnter = location => {
    dispatch(
      setNodeData({ triggerCondition: _uniq([...triggerCondition, location]) }),
    );
  };

  const onSetTags = locations => {
    dispatch(setNodeData({ triggerCondition: locations }));
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.clickType')}</div>
      <AutoCompletedTextField
        className={classnames({
          [classes.error]: isError && !triggerCondition.length,
        })}
        defaultTags={triggerCondition || []}
        placeholder={t(`locationPlaceholder`)}
        candidates={[]}
        type="inline"
        onEnter={onTagEnter}
        onSetTags={onSetTags}
        onChange={() => {}}
        multiline
      />
    </div>
  );
};

export default Location;
